export function initMobileSubMenu() {


    function toggleSubMenu(event) {
    const targetElement = event.target;
    const parentLi = targetElement.closest('li.has-children');

    if (parentLi) {
      const childUl = parentLi.querySelector('ul');

      if (childUl) {
        const allChildUls = document.querySelectorAll('.mobile-menu__links li.has-children ul.open');

        allChildUls.forEach((ul) => {
          if (ul !== childUl) {
            ul.classList.remove('open');
          }
        });

        if (targetElement.tagName.toLowerCase() === 'p') {
          event.preventDefault();
        }

        childUl.classList.toggle('open');
      }
    }
  }

  const mobileMenuLinks = document.querySelector('.mobile-menu__links');

  if (mobileMenuLinks) {
    mobileMenuLinks.addEventListener('click', toggleSubMenu);
  }



}
